import { Component, computed, input, output } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ProjectIndustry } from '@app/shared/types/models/project-industry/project-industry.model';
import { TranslatePipe } from '@ngx-translate/core';

export type TaskIndustrySelectMode = 'row' | 'column';

@Component({
  selector: 'proffeo-task-industry-select',
  templateUrl: './task-industry-select.component.html',
  imports: [MatIconModule, TranslatePipe, MatTooltipModule],
  host: {
    class: 'flex min-w-0 max-w-full items-center gap-1'
  }
})
export class TaskIndustrySelectComponent {
  protected readonly industryPresent = computed(() => {
    const industryName = this.projectIndustry()?.industry()?.name;
    return industryName !== null && industryName !== undefined;
  });

  public readonly projectIndustry = input.required<ProjectIndustry>();
  public readonly isReadonly = input<boolean>(false);
  public readonly minimalMode = input<boolean>(false);
  public readonly showIcon = input<boolean>(true);
  public readonly isSmall = input<boolean>(false);

  public readonly industryClicked = output<void>();

  protected clicked(): void {
    if (this.isReadonly()) return;
    this.industryClicked.emit();
  }
}
